import React, { useState } from 'react';
import Lottie from 'react-lottie';
import animation from '../lotties/69929-little-fox-copywriter.json';

const LoaderComponent = (props) => {

    const [loaderIsStopped, setLoaderIsStopped] = useState(false);
    const [loaderIsPaused, setLoaderIsPaused] = useState(false);

    const animationOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    // const waitingLoaderOptions = {
    //   loop: true,
    //   autoplay: true,
    //   animationData: waitingLoader,
    //   rendererSettings: {
    //     preserveAspectRatio: 'xMidYMid slice'
    //   }
    // };

    return (
        <div>
            <Lottie options={animationOptions}
                height={400}
                width={400}
                isStopped={loaderIsStopped}
                isPaused={loaderIsPaused} />
            {/* <Lottie options={waitingLoaderOptions}
        height={400}
        width={400}
        isStopped={loaderIsStopped}
        isPaused={loaderIsPaused} /> */}
            <h5>Note: The Results will arrive within a minute</h5>
        </div>
    );
};

export default LoaderComponent;